import { useCallback } from 'react';
import { useCartStore, useShallow } from 'components/shared/Cart';
import { useBuyContext } from './BuyContext';
import { useBuyLineItems } from './useBuyLineItems';

export type UseBuyCheckoutReturn = {
  checkout: () => Promise<void>;
  isLoading: boolean;
};

export const useBuyCheckout = (): UseBuyCheckoutReturn => {
  const CartClient = useCartStore(
    useShallow((s) => ({ addToCart: s.addToCart })),
  );
  const { isCheckoutLoading, setCheckoutLoading } = useBuyContext();
  const lineItems = useBuyLineItems();

  const checkout = useCallback(async () => {
    if (lineItems.length === 0) return;
    setCheckoutLoading(true);
    try {
      await CartClient.addToCart(lineItems, true);
    } catch (error) {
      console.error('useBuyCheckout: addToCart failed', error);
    } finally {
      setCheckoutLoading(false);
    }
  }, [CartClient, lineItems, setCheckoutLoading]);

  return { checkout, isLoading: isCheckoutLoading };
};
